import { ChevronRight } from "lucide-react";
import { Private } from "../../components/Privacy";
import type { InsightTotals } from "./insight-types";
import { figure, tickerClass } from "./insight-format";

/** Headline ticker: spending with its move against the baseline, then income / net / daily cells. */
export default function InsightsSummary({ totals, currency, comparisonLabel, baseline, onOpenSpending, onOpenIncome, onOpenAll }: {
  totals: InsightTotals; currency: string; comparisonLabel: string; baseline: string;
  onOpenSpending?: () => void; onOpenIncome?: () => void; onOpenAll?: () => void;
}) {
  const { change, changePercent } = totals;
  const move = tickerClass(change);
  const changeCopy = change === null
    ? totals.previousCount ? "Comparison unavailable" : "No comparable spending yet"
    : change === 0
      ? `Same as ${baseline}`
      : `${change > 0 ? "▲" : "▼"} ${figure(Math.abs(change), currency)}${changePercent === null ? "" : ` · ${Math.abs(changePercent).toFixed(1)}%`}`;
  const negative = totals.remaining !== null && totals.remaining < 0;

  return (
    <section className="panel insight-board insights-summary">
      <button type="button" className="insight-board-hero insight-stat-main" onClick={onOpenSpending} aria-label={`View ${currency} spending transactions`}>
        <span className="insight-board-label">Spending <em>{currency}</em></span>
        <span className="insight-board-value"><Private>{figure(totals.spending, currency)}</Private></span>
        <span className="insight-board-move">
          <span className={`insight-ticker ${move}`}><Private>{changeCopy}</Private></span>
          <span className="insight-board-vs">{comparisonLabel}</span>
        </span>
        <ChevronRight size={16} className="insight-board-chevron" aria-hidden="true" />
      </button>
      <div className="insight-board-cells">
        <button type="button" onClick={onOpenIncome} aria-label={`View ${currency} income transactions`}>
          <span>Income</span>
          <strong><Private>{figure(totals.income, currency)}</Private></strong>
        </button>
        <button type="button" onClick={onOpenAll} aria-label="View all transactions this month">
          <span>After spending</span>
          <strong className={negative ? "negative" : ""}><Private>{figure(totals.remaining, currency)}</Private></strong>
        </button>
        <button type="button" onClick={onOpenSpending} aria-label="View daily spending across elapsed calendar days">
          <span>Daily avg</span>
          <strong><Private>{figure(totals.dailyAverage, currency)}</Private></strong>
        </button>
      </div>
    </section>
  );
}
